<template>
  <div>
    <router-view/>
    <Footer/>
    <div id="background"/>
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'

export default {
  name: 'App',
  components: {
    Footer
  }
}
</script>

<style lang="less">
body {
  background-color: #e7f6f8;
  font-family: 'Open Sans', sans-serif;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: 'Open Sans Condensed', sans-serif;
  }

  div.banner a {
    color: white;
  }

  blockquote a {
    color: #397884;

    &:hover {
      color: white;
      background-color: #397884;
      text-decoration: none;
    }
  }

  div#background {
    background-image: url('assets/background.png');
    background-position: center center;
    background-repeat: repeat;
    height: 100%;
    opacity: 0.1;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: -1;
  }

  .button-xsmall {
    font-size: 70%;
  }

  .button-small {
    font-size: 85%;
  }

  .button-large {
    font-size: 110%;
  }

  .button-xlarge {
    font-size: 125%;
  }

  .button-success,
  .button-error,
  .button-warning,
  .button-secondary,
  .button-filter {
    color: white;
    border-radius: 4px;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  }

  .button-success {
    background: rgb(28, 184, 65);
  }

  .button-error {
    background: rgb(202, 60, 60);
  }

  .button-warning {
    background: rgb(223, 117, 20);
  }

  .button-secondary {
    background: rgb(66, 184, 221);
  }

  .button-filter {
    background: #9b23cb;
  }

  #order-button {
    font-weight: bold;
    font-family: 'Open Sans Condensed', sans-serif;
    color: white;
    border-radius: 4px;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    background-color: #ea3623;
  }

  #vip-button {
    background-color: #397884;
    color: white;
    font-family: 'Open Sans Condensed', sans-serif;
  }

  table.crud {
    width: 100%;

    border-width: 0px;

    * {
      border-color: #b7e6e2;
    }

    thead {
      background-color: transparent;
    }

    thead tr th:last-child,
    tbody tr td:last-child {
      text-align: right;
    }

    thead tr th form input.pure-input-rounded {
      font-size: 70%;
      font-weight: normal;
    }
  }
}
</style>
